import AudioWaveformIcon from '@atlaskit/icon-lab/core/audio-waveform';
import * as React from 'react';

export function SvgWaveform() {
  return <AudioWaveformIcon label="" testId="ads-refreshed-icon" />;
}
